window.ROAMUNO_DEVICE_COMPATIBILITY = {
  updatedAt: '2026-08-31',
  brands: [
    {
      name: 'Apple',
      platform: 'ios',
      models: [
        'iPhone 17e', 'iPhone 17', 'iPhone Air', 'iPhone 17 Pro', 'iPhone 17 Pro Max',
        'iPhone 16e', 'iPhone 16', 'iPhone 16 Plus', 'iPhone 16 Pro', 'iPhone 16 Pro Max',
        'iPhone 15', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15 Pro Max',
        'iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max',
        'iPhone SE (3rd generation)', 'iPhone SE (2nd generation)',
        'iPhone 13 mini', 'iPhone 13', 'iPhone 13 Pro', 'iPhone 13 Pro Max',
        'iPhone 12 mini', 'iPhone 12', 'iPhone 12 Pro', 'iPhone 12 Pro Max',
        'iPhone 11', 'iPhone 11 Pro', 'iPhone 11 Pro Max', 'iPhone XS', 'iPhone XS Max', 'iPhone XR',
        'iPad Pro 13-inch (M4 or later) Wi-Fi + Cellular', 'iPad Pro 11-inch (M4 or later) Wi-Fi + Cellular',
        'iPad Pro 12.9-inch (3rd-6th generation) Wi-Fi + Cellular', 'iPad Pro 11-inch (1st-4th generation) Wi-Fi + Cellular',
        'iPad Air 13-inch (M2 or later) Wi-Fi + Cellular', 'iPad Air 11-inch (M2 or later) Wi-Fi + Cellular',
        'iPad Air (3rd-5th generation) Wi-Fi + Cellular', 'iPad (7th generation or later) Wi-Fi + Cellular',
        'iPad mini (5th generation or later) Wi-Fi + Cellular'
      ]
    },
    {
      name: 'Samsung',
      platform: 'samsung',
      models: [
        'Galaxy S25 Edge', 'Galaxy S25 FE', 'Galaxy S25', 'Galaxy S25+', 'Galaxy S25 Ultra',
        'Galaxy Z Fold7', 'Galaxy Z Flip7', 'Galaxy Z Flip7 FE', 'Galaxy A56', 'Galaxy A36', 'Galaxy XCover7 Pro',
        'Galaxy Tab S11', 'Galaxy Tab S11 Ultra',
        'Galaxy S24 FE', 'Galaxy S24', 'Galaxy S24+', 'Galaxy S24 Ultra',
        'Galaxy Z Fold6', 'Galaxy Z Flip6', 'Galaxy A55', 'Galaxy A35', 'Galaxy XCover7',
        'Galaxy Tab S10', 'Galaxy Tab S10+', 'Galaxy Tab S10 Ultra',
        'Galaxy S23 FE', 'Galaxy S23', 'Galaxy S23+', 'Galaxy S23 Ultra',
        'Galaxy Z Fold5', 'Galaxy Z Flip5', 'Galaxy A54', 'Galaxy Tab S9', 'Galaxy Tab S9+', 'Galaxy Tab S9 Ultra',
        'Galaxy S22', 'Galaxy S22+', 'Galaxy S22 Ultra', 'Galaxy Z Fold4', 'Galaxy Z Flip4',
        'Galaxy S21', 'Galaxy S21+', 'Galaxy S21 Ultra', 'Galaxy Z Fold3', 'Galaxy Z Flip3',
        'Galaxy S20', 'Galaxy S20+', 'Galaxy S20 Ultra',
        'Galaxy Z Fold2', 'Galaxy Z Flip 5G', 'Galaxy Z Flip', 'Galaxy Fold'
      ]
    },
    {
      name: 'Google Pixel',
      platform: 'android',
      models: [
        'Pixel 10a', 'Pixel 10', 'Pixel 10 Pro', 'Pixel 10 Pro XL', 'Pixel 10 Pro Fold',
        'Pixel 9a', 'Pixel 9', 'Pixel 9 Pro', 'Pixel 9 Pro XL', 'Pixel 9 Pro Fold',
        'Pixel 8a', 'Pixel 8', 'Pixel 8 Pro', 'Pixel Fold', 'Pixel 7a', 'Pixel 7', 'Pixel 7 Pro',
        'Pixel 6a', 'Pixel 6', 'Pixel 6 Pro', 'Pixel 5a 5G', 'Pixel 5', 'Pixel 4a 5G', 'Pixel 4a', 'Pixel 4', 'Pixel 4 XL'
      ]
    },
    {
      name: 'Motorola',
      platform: 'android',
      models: [
        'motorola razr 2026',
        'motorola razr ultra 2025', 'motorola razr+ 2025', 'motorola razr 2025', 'motorola edge 60 pro', 'motorola edge 60',
        'motorola razr+ 2024', 'motorola razr 2024', 'motorola razr 50 ultra', 'motorola razr 50',
        'motorola edge 50 ultra', 'motorola edge 50 pro', 'motorola edge 50 fusion', 'moto g75 5G', 'moto g55 5G', 'moto g54 5G',
        'motorola razr+ 2023', 'motorola razr 2023', 'motorola razr 40 ultra', 'motorola razr 40',
        'motorola edge 40 pro', 'motorola edge 40', 'motorola edge+ 2023', 'motorola edge 2023',
        'moto g53 5G', 'motorola razr 5G'
      ]
    },
    {
      name: 'Xiaomi',
      platform: 'android',
      models: [
        'Xiaomi 15 Ultra', 'Xiaomi 15', 'Redmi Note 14 Pro+ 5G', 'Xiaomi 14 Ultra', 'Xiaomi 14T Pro', 'Xiaomi 14T', 'Xiaomi 14',
        'Xiaomi 13 Pro', 'Xiaomi 13', 'Xiaomi 13T Pro', 'Xiaomi 13T', 'Xiaomi 12T Pro'
      ]
    },
    {
      name: 'Sony',
      platform: 'android',
      models: [
        'Xperia 1 VIII', 'Xperia 1 VII', 'Xperia 10 VII', 'Xperia 1 VI', 'Xperia 10 VI',
        'Xperia 1 V', 'Xperia 5 V', 'Xperia 10 V', 'Xperia 1 IV', 'Xperia 5 IV', 'Xperia 10 IV'
      ]
    },
    {
      name: 'OPPO',
      platform: 'android',
      models: [
        'OPPO Reno 14 Pro 5G', 'OPPO Find X8 Pro', 'OPPO Find X8', 'OPPO Reno 12 Pro 5G',
        'OPPO Find N3', 'OPPO Find N3 Flip', 'OPPO Find X5 Pro', 'OPPO Find X5', 'OPPO Find X3 Pro'
      ]
    },
    {
      name: 'OnePlus',
      platform: 'android',
      models: ['OnePlus 13', 'OnePlus 12', 'OnePlus 11']
    },
    {
      name: 'HONOR',
      platform: 'android',
      models: [
        'HONOR Magic7 Pro', 'HONOR Magic V3', 'HONOR Magic6 Pro', 'HONOR 200 Pro',
        'HONOR Magic V2', 'HONOR Magic5 Pro', 'HONOR 90', 'HONOR Magic4 Pro'
      ]
    },
    {
      name: 'HUAWEI',
      platform: 'android',
      models: ['HUAWEI Mate 40 Pro', 'HUAWEI P40 Pro', 'HUAWEI P40']
    }
  ]
};
